import { Link } from "react-router-dom";
import { Phone, ArrowLeft, ArrowUpRight } from "lucide-react";
import { Reveal, MaskLine, Eyebrow } from "../components/Reveal";

const IntelligencePage = () => (
  <main data-testid="intelligence-page">
    <section className="bg-ivory pt-40 pb-20 lg:pt-48 lg:pb-24">
      <div className="mx-auto max-w-[88rem] px-6 lg:px-12">
        <MaskLine delay={0.2}>
          <Link to="/" data-testid="intelligence-link-home" className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-ink/55 transition-colors hover:text-eucalyptus">
            <ArrowLeft className="h-4 w-4" /> Back to Toro Finance Group
          </Link>
        </MaskLine>
        <div className="mt-8">
          <MaskLine delay={0.3}>
            <Eyebrow>The AI tool — in development</Eyebrow>
          </MaskLine>
          <h1 className="mt-4 font-display text-[clamp(2.6rem,6vw,5.5rem)] font-medium leading-[1.05] tracking-[-0.01em] text-ink">
            <MaskLine delay={0.4}>Is your rate</MaskLine>
            <MaskLine delay={0.55}>
              <span className="italic text-eucalyptus">within range?</span>
            </MaskLine>
          </h1>
          <MaskLine delay={0.7}>
            <p className="mt-7 max-w-xl text-base leading-relaxed text-ink/70 sm:text-lg">
              Toro iNtelligence is the tool we&rsquo;re building to compare
              your product in the market — so you can see whether your rate
              sits within range of what&rsquo;s being offered today.
            </p>
          </MaskLine>
        </div>
      </div>
    </section>

    <section className="bg-ivory pb-24 lg:pb-32">
      <div className="mx-auto max-w-[88rem] px-6 lg:px-12">
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
          <Reveal delay={0.05}>
            <div data-testid="intelligence-feature-compare" className="flex h-full flex-col rounded-2xl border border-ink/10 bg-cream p-8 lg:p-10">
              <h3 className="font-display text-3xl font-medium text-ink">
                Compare in market
              </h3>
              <p className="mt-4 leading-relaxed text-ink/65">
                Put your product up against the market and see how it stacks —
                clearly, honestly, in plain numbers.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div data-testid="intelligence-feature-range" className="flex h-full flex-col rounded-2xl border border-ink/10 bg-cream p-8 lg:p-10">
              <h3 className="font-display text-3xl font-medium text-ink">
                Rate in range?
              </h3>
              <p className="mt-4 leading-relaxed text-ink/65">
                A straight answer to one question: is your rate where the
                market is today?
              </p>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <p className="mt-6 font-mono text-[10px] leading-relaxed tracking-[0.08em] text-ink/45" data-testid="intelligence-note">
            Toro iNtelligence is currently in development — as it grows, so
            does this page.
          </p>
        </Reveal>
      </div>
    </section>

    <section className="bg-mint py-20 lg:py-28">
      <div className="mx-auto flex max-w-[88rem] flex-col items-start gap-8 px-6 lg:flex-row lg:items-center lg:justify-between lg:px-12">
        <Reveal>
          <h2 className="font-display text-3xl font-medium leading-[1.1] text-ink sm:text-4xl">
            Want eyes on your rate today?
            <span className="italic text-eucalyptus"> Ask Tory.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="flex flex-col gap-4 sm:flex-row">
            <a
              href="tel:0414345736"
              data-testid="intelligence-cta-call"
              className="group inline-flex items-center justify-center gap-3 rounded-full bg-ink px-8 py-4 text-sm font-semibold text-ivory transition-all duration-300 hover:-translate-y-0.5 hover:bg-eucalyptus hover:text-ivory"
            >
              <Phone className="h-4 w-4 transition-transform duration-300 group-hover:rotate-12" />
              Call Tory — 0414 345 736
            </a>
            <a
              href="/#contact"
              data-testid="intelligence-cta-callback"
              className="group inline-flex items-center justify-center gap-3 rounded-full border border-ink/25 px-8 py-4 text-sm font-medium text-ink transition-all duration-300 hover:border-eucalyptus hover:text-eucalyptus"
            >
              Request a callback
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  </main>
);

export default IntelligencePage;
